import { datadogLogs } from '@datadog/browser-logs';
import * as _ from 'lodash';
import config from './config';

const PII_FIELDS_BLACKLIST = [
  'firstName',
  'lastName',
  'phoneNumber',
  'question',
  'amount',
  'secondMemberFirstName',
  'secondMemberLastName',
  'accounts',
  'account',
];

/* eslint-disable */
const DDLogs = {
  init() {
    datadogLogs.init({
      clientToken: config.get().datadogLogsClientToken,
      forwardErrorsToLogs: true,
      site: 'datadoghq.com',
      service: 'greta',

      beforeSend: (log) => {
        // discard client side network errors
        if (log.http && log.http.status_code === 0) {
          return false;
        }
      },
    });

  },

  addGlobalContext(ctxName: unknown, ctxValue: unknown) {
    // @ts-ignore
    DD_LOGS.addLoggerGlobalContext(ctxName, ctxValue);
  },

  log(message: string, data?: object, level?: string) {
    const dataWithoutPII = _.pickBy(data, (value, key) => !_.includes(PII_FIELDS_BLACKLIST, key));
    // @ts-ignore
    DD_LOGS.logger.log(message, dataWithoutPII, level);
  },

  info(message: string, data?: object) {
    this.log(message, data);
  },

  warn(message: string, data?: object) {
    this.log(message, data, 'warn');
  },

  error(message: string, data?: any) {
    const dataWithoutPII = _.pickBy(data, (value, key) => !_.includes(PII_FIELDS_BLACKLIST, key));
    // @ts-ignore
    DD_LOGS.logger.error(message, { ...dataWithoutPII, originalError: data?.error });
    console.error(message, { ...dataWithoutPII, originalError: data?.error });
  },

  logBusinessEvent(message: string, data?: object) {
    const dataWithoutPII = _.pickBy(data, (value, key) => !_.includes(PII_FIELDS_BLACKLIST, key));
    // @ts-ignore
    DD_LOGS.logger.log(message, { ...dataWithoutPII, businessEvent: true });
  },

  errorBusinessEvent(message: string, data?: object) {
    const dataWithoutPII = _.pickBy(data, (value, key) => !_.includes(PII_FIELDS_BLACKLIST, key));
    // @ts-ignore
    DD_LOGS.logger.error(message, { ...dataWithoutPII, originalError: data.error, businessEvent: true });
  },
};

export default DDLogs;
